import React from 'react';
import * as AppActions from '../AppActions';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import {message} from 'antd';

export function deleteEmptyParams(params) {
  let next = {};
  for (let key in params) {
    let value = params[key];
    if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
      // check is object
      let nested = deleteEmptyParams(value);
      if (Object.keys(nested).length > 0) {
        // check is non empty object
        next[key] = nested;
      }
    } else if (params[key]) {
      //check value exists
      next[key] = params[key];
    }
  }
  return next;
}

export default function useDocuments(props) {
  const {
    defaultFilters = {},
    collection,
    projection,
    fetchAllFn,
    sorting = null,
  } = props;
  const [records, setRecords] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [filters, setFilters] = React.useState({
    ...defaultFilters,
    offset: 0,
    limit: defaultFilters.limit ?? 10, // default page size
  });
  const [loading, setLoading] = React.useState(false);

  const refresh = React.useCallback(async () => {
    AppActions.setLoading(true);
    setLoading(true);
    try {
      const {limit, offset, ...rest} = filters;
      let resp = {};
      if (typeof fetchAllFn === 'function') {
        resp = await fetchAllFn({
          query: deleteEmptyParams(rest),
          limit,
          offset,
          projection,
          sorting,
        });
      } else {
        resp = await AppActions.fetchDocuments(collection, {
          query: deleteEmptyParams(rest),
          limit,
          offset,
          projection,
          sorting,
        });
      }

      setTotal(resp.total);
      setRecords(resp.results);

      if (resp.results.length === 0) {
        message.info('無相關搜尋結果');
      }
    } catch (ex) {
      console.warn('REV_DBG', ex);
    }
    setLoading(false);
    AppActions.setLoading(false);
  }, [filters]);

  return {
    records,
    total,
    refresh,
    filters,
    setFilters,
    loading,
  };
}
